"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductEditorTableTabs = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const localization_1 = require("../../../../localization");
const ProductEditorTableTabs = ({ activeTab, classifiedTotal, onTabChange, allTotal, unclassifiedTotal, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const unclassifiedTitle = t({ key: 'PRODUCT_EDITOR_TABLE_TABS_UNCLASSIFIED' });
    const classifiedTitle = t({ key: 'PRODUCT_EDITOR_TABLE_TABS_CLASSIFIED' });
    const allTitle = t({ key: 'PRODUCT_EDITOR_TABLE_TABS_ALL' });
    const tabLabels = [
        `${unclassifiedTitle} (${unclassifiedTotal})`,
        `${classifiedTitle} (${classifiedTotal})`,
        `${allTitle} (${allTotal})`,
    ];
    return react_1.default.createElement(ui_components_1.TabToolBar, { activeTab: activeTab, handleTabChange: onTabChange, tabLabels: tabLabels });
};
exports.ProductEditorTableTabs = ProductEditorTableTabs;
exports.default = exports.ProductEditorTableTabs;
